import React from "react";
import Button from "@mui/material/Button";

const CustomButton = ({
  text,
  className,
  onClick,
  style,
  btnColor,
  btnTextColor = "white",
  Icon,
  disabled,
  bordercolor,
  endIcon,
  height,
  width,
}) => {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
      }}
    >
      <Button
        variant="contained"
        className={`${className}`}
        onClick={onClick}
        startIcon={Icon ? Icon : ""}
        endIcon={endIcon ? endIcon : ""}
        disabled={disabled ? disabled : false}
        sx={{
          height: height ? height : "45px",
          backgroundColor: btnColor ? btnColor : "transparent",
          color: btnTextColor,
          textTransform: "none",
          width: width ? width : "100%",
          border: `1px solid ${bordercolor}`,
          borderRadius: "11px",
          "&:hover": {
            backgroundColor: "transparent", // or any other desired color
          },
          "&:disabled": {
            color: btnTextColor,
            backgroundColor: btnColor,
            opacity: 0.5,
          },
        }}
        style={{ style }}
      >
        <span
          className="py-2"
          style={{ fontSize: "16px", fontFamily: "PoppinsSemiBold" }}
        >
          {text}
        </span>
      </Button>
    </div>
  );
};

export default CustomButton;
